// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.


const params: URLSearchParams = new URLSearchParams(window.location.search)
const accountId: number | null = (!!params.get("rlm"))
  ? parseInt(params.get("rlm") as string)
  : null
if (accountId !== null) {
  localStorage.setItem("Account.id", accountId.toString())
}


export const getCurrentAccountId: () => null | number = () => {
  return accountId
}


export const getLastUsedAccountId: () => null | number = () => {
  const rawValue = localStorage.getItem("Account.id")
  return (!rawValue) ? null : parseInt(rawValue)
}


export const constructUrl: (path: string) => string = (path) => {
  const url = new URL(path, window.location.origin)
  if (accountId !== null) {
    url.searchParams.set("rlm", accountId.toString())
  }
  return `${path}${url.search}`
}